import type { ReactNode } from 'react';
import { NoAccess } from '@/components/QueryBoundary';
import { usePermissions } from './session';

/** Route-level permission gate (presentation only; the API enforces the same rule independently). */
export function Require({ permission, children }: { permission: string | string[]; children: ReactNode }) {
  const { canAny } = usePermissions();
  return canAny(Array.isArray(permission) ? permission : [permission]) ? <>{children}</> : <NoAccess />;
}
